import { createSlice } from "@reduxjs/toolkit";
import jwtDecode from "jwt-decode";
const initialState = {
  isAuthenticated: false,
  loader: false,
};

const authenticationSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    login(state) {
      state.loader = true;
    },
    loginSuccess(state, action) {
      state.loader = false;
      state.isAuthenticated = !!action.payload.token;
      state.token = JSON.stringify(action.payload.token);
      localStorage.setItem("isAuthenticated", state.isAuthenticated);
      localStorage.setItem("token", state.token);

      const decoded = jwtDecode(action.payload.token);
      if (decoded) {
        state.user = JSON.stringify(decoded);
        localStorage.setItem("user", JSON.stringify(decoded));
      }
      if (action.payload.roles) {
        state.roles = action.payload.roles;
        localStorage.setItem("roles", action.payload.roles);
      }
    },
    loginFailure(state) {
      state.loader = false;
      state.isAuthenticated = false;
    },
    loginSessionAvailable(state) {
      let token = localStorage.getItem("token");
      if (token) {
        const decoded = jwtDecode(token);
        const date = new Date(0);
        date.setUTCSeconds(decoded.exp);
        if (date === undefined || !(date.valueOf() > new Date().valueOf())) {
          state.isAuthenticated = false;
        } else {
          state.isAuthenticated = true;
        }
      } else {
        state.isAuthenticated = false;
      }
    },
  },
});

export const { login, loginSuccess, loginFailure, loginSessionAvailable } =
  authenticationSlice.actions;
export default authenticationSlice.reducer;
